// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[1]!../../node_modules/less-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../node_modules/react-responsive-carousel/lib/styles/carousel.min.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 768px) {
  #propertyToSearch .table-responsive {
    border: none;
  }
}
#propertyToSearch table tbody {
  cursor: pointer;
}
#propertyToSearch table tbody td {
  padding: 5px 4px 5px 4px !important;
  position: relative;
}
#propertyToSearch table tbody td .propertyCommentBlock {
  position: absolute;
  width: 48em !important;
  background: #fafafa;
  cursor: default;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.6);
  z-index: 9;
  left: -37em;
  top: 3.3em;
}
#propertyToSearch table tbody td .propertyCommentBlock ul.infoList {
  float: left;
  width: 95%;
}
#propertyToSearch table tbody td .propertyCommentBlock ul.infoList li {
  margin: 0.5em 1em 0.5em 2em;
}
#propertyToSearch table tbody td .propertyCommentBlock ul.infoList li:last-child {
  margin-bottom: 0.5em;
}
#propertyToSearch table tbody td .propertyCommentBlock ul.infoList li:first-child {
  margin-top: 0.5em;
}
#propertyToSearch table tbody .btn-danger {
  border-color: #d9534f;
}
#propertyToSearch table tbody .btn-danger:focus {
  border-color: #C9302F;
}
#propertyToSearch table tbody .btn-danger:active {
  border: 1px solid #c9302c;
}
#propertyToSearch table tbody .btn-danger:hover,
#propertyToSearch table tbody .btn-danger:active:hover {
  border-color: #c9302c;
}
#propertyToSearch table tbody input:focus {
  outline: none;
}
#propertyToSearch table .button {
  font-style: normal;
  padding: 2px 4px;
  border-radius: 1px;
  margin: 2px 2px;
  cursor: default;
}
#propertyToSearch table tr.selected {
  background-color: #eecd7e !important;
}
#propertyToSearch table th:nth-child(2) {
  max-width: 80px;
}
#propertyToSearch table th:nth-child(3) {
  min-width: 210px;
}
#propertyToSearch table th:nth-child(4) {
  min-width: 110px;
}
#propertyToSearch table th:nth-child(5) {
  max-width: 120px;
}
#propertyToSearch table th:nth-child(6) {
  max-width: 155px;
}
#propertySearchContent {
  overflow: hidden;
  padding: 0 0 1em 0;
  position: relative;
}
#propertySearchEditForm .wiz-wrapper-2 {
  margin-bottom: 1em;
}
.serviceHeader {
  display: flex;
  flex-direction: row;
}
.serviceHeader .providedBy {
  margin-left: auto;
  float: right;
}
ul.navMenu {
  padding: 0;
  display: flex;
}
ul.navMenu li {
  height: 60px;
  position: relative;
  cursor: pointer;
  list-style-type: none;
  width: calc(100% / 3);
  display: flex;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
ul.navMenu li button {
  width: 100%;
  height: 100%;
  padding: 0;
  position: relative;
  display: flex;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  border: 0px;
}
ul.navMenu li .topTriangle {
  border-style: solid;
  border-width: 0 25px 30px 0;
  border-color: transparent #d9d9d9 transparent transparent;
}
ul.navMenu li .topTriangle.done {
  border-color: transparent #97a4bf transparent transparent;
}
ul.navMenu li .topTriangle.current {
  border-color: transparent #3e4b65 transparent transparent;
}
ul.navMenu li .stepContent {
  height: 100%;
  width: 100%;
  background-color: #d9d9d9;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
ul.navMenu li .stepContent.done {
  background-color: #97a4bf;
}
ul.navMenu li .stepContent.current {
  background-color: #3e4b65;
}
ul.navMenu li .frontTriangle {
  border-style: solid;
  border-width: 30px 0 30px 25px;
  border-color: transparent transparent transparent #d9d9d9;
}
ul.navMenu li .frontTriangle.done {
  border-color: transparent transparent transparent #97a4bf;
}
ul.navMenu li .frontTriangle.current {
  border-color: transparent transparent transparent #3e4b65;
}
ul.navMenu li .bottomTriangle {
  justify-self: end;
  border-style: solid;
  border-width: 0 0 30px 25px;
  border-color: transparent transparent #d9d9d9 transparent;
}
ul.navMenu li .bottomTriangle.done {
  border-color: transparent transparent #97a4bf transparent;
}
ul.navMenu li .bottomTriangle.current {
  border-color: transparent transparent #3e4b65 transparent;
}
ul.navMenu li.current {
  color: white;
}
ul.navMenu li.current button {
  color: white;
}
ul.navMenu li.current .topTriangle {
  border-color: transparent #3e4b65 transparent transparent;
}
ul.navMenu li.current .stepContent {
  background-color: #3e4b65;
}
ul.navMenu li.current .frontTriangle {
  border-color: transparent transparent transparent #3e4b65;
}
ul.navMenu li.current .bottomTriangle {
  border-color: transparent transparent #3e4b65 transparent;
}
ul.navMenu li.done .topTriangle {
  border-color: transparent #97a4bf transparent transparent;
}
ul.navMenu li.done .stepContent {
  background-color: #97a4bf;
}
ul.navMenu li.done .frontTriangle {
  border-color: transparent transparent transparent #97a4bf;
}
ul.navMenu li.done .bottomTriangle {
  border-color: transparent transparent #97a4bf transparent;
}
ul.navMenu li:last-child {
  margin-right: 0;
}
ul.navMenu li:first-child .topTriangle,
ul.navMenu li:first-child .bottomTriangle {
  border: none;
  width: 100%;
  background-color: #d9d9d9;
}
ul.navMenu li:first-child.done .topTriangle,
ul.navMenu li:first-child.done .bottomTriangle {
  background-color: #97a4bf;
}
ul.navMenu li:first-child.current .topTriangle,
ul.navMenu li:first-child.current .bottomTriangle {
  background-color: #3e4b65;
}
ul.navMenu li:last-child .frontTriangle {
  border: none;
  background-color: #d9d9d9;
}
ul.navMenu li:last-child.done .frontTriangle {
  background-color: #97a4bf;
}
ul.navMenu li:last-child.current .frontTriangle {
  background-color: #3e4b65;
}
ul.navMenu .stepDesc {
  float: left;
  width: 100%;
  margin: 0.25em;
  font-size: 13px;
  font-family: Arial, sans-serif;
  display: inline-block;
  text-align: center;
}
ul.navMenu .stepName {
  font-size: 17px;
  width: 100%;
  display: inline-block;
  text-transform: uppercase;
  text-align: center;
  font-weight: bold;
}
@media (max-width: 1200px) {
  ul.navMenu li .stepDesc {
    display: none;
  }
  ul.navMenu .stepName {
    font-size: 0.94em;
  }
}
.closePropertyCommentBlock {
  color: red !important;
  text-decoration: none !important;
}
.closePropertyCommentBlock:hover {
  transform: scale(1.2, 1.2);
}
.undoContainer {
  float: left;
  width: 200%;
  transition: height 600ms, left 600ms cubic-bezier(0.43, 0.01, 1, 1);
  position: relative;
  left: -100%;
  overflow: hidden;
  padding-top: 2px;
}
.undoContainer .undoBlock {
  float: left;
  padding: 0;
  margin-bottom: 20px;
}
.undoContainer .undoBlock .undoContent {
  float: left;
  width: 100%;
  background-color: #6e6e6e;
  color: #f5f5f5;
  padding: 0.5em 1em;
  text-align: center;
}
.undoContainer .undoBlock .undoContent a {
  color: #E7B848;
  cursor: pointer;
}
.undoContainer .undoBlock .undoContent a.doneAction {
  float: left;
}
.undoContainer .undoBlock .undoContent a.undoAction {
  float: right;
}
.docketYearPopover {
  width: 200px;
  height: 60px;
}
.carousel .slider-wrapper .formBlock {
  margin: 3px 5px 20px;
}
.carousel .slider-wrapper .serviceBlock {
  width: calc(100% - 10px);
}
.carousel .slider-wrapper .slide {
  text-align: left;
}
.carousel .slider-wrapper .one-field-carousel {
  line-height: 0;
}
.carousel .slider-wrapper .one-field-carousel .formBlock {
  line-height: 1;
}
.carousel .slider-wrapper .one-field-carousel .formBlock:last-child {
  display: none;
}
.carousel .slider-wrapper .one-field-carousel .formBlock.roll-in-block-small {
  min-height: 62px;
  display: flex;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/style/propertySearchOrder.less"],"names":[],"mappings":"AAGA;EACE;IACE,YAAA;EADF;AACF;AAIA;EAEI,eAAA;AAHJ;AACA;EAKM,mCAAA;EACA,kBAAA;AAHN;AAHA;EASQ,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,yCAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;AAHR;AAbA;EAmBU,WAAA;EACA,UAAA;AAHV;AAjBA;EAuBY,2BAAA;AAHZ;AApBA;EA2BY,oBAAA;AAJZ;AAvBA;EA8BY,iBAAA;AAJZ;AA1BA;EAsCM,qBAAA;AATN;AA7BA;EA0CM,qBAAA;AAVN;AAhCA;EA8CM,yBAAA;AAXN;AAnCA;;EAkDM,qBAAA;AAXN;AAvCA;EAsDM,aAAA;AAZN;AA1CA;EA2DI,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AAdJ;AAoBA;EAGM,oCAAA;AApBN;AAiBA;EAQM,eAAA;AAtBN;AAcA;EAWM,gBAAA;AAtBN;AAWA;EAcM,gBAAA;AAtBN;AAQA;EAiBM,gBAAA;AAtBN;AAKA;EAoBM,gBAAA;AAtBN;AA2BA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;AAzBF;AA6BA;EACE,kBAAA;AA3BF;AA8BA;EACE,aAAA;EACA,mBAAA;AA5BF;AA0BA;EAKI,iBAAA;EACA,YAAA;AA5BJ;AAgCA;EACE,UAAA;EACA,aAAA;AA9BF;AA4BA;EAKI,YAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,qBAAA;EACA,aAAA;EACA,mCAAA;EACA,kCAAA;AA9BJ;AAkBA;EAeM,WAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,mCAAA;EACA,kCAAA;EACA,WAAA;AA9BN;AAQA;EA0BM,mBAAA;EACA,2BAAA;EACA,yDAAA;AA/BN;AAiCM;EACE,yDAAA;AA/BR;AAkCM;EACE,yDAAA;AAhCR;AAHA;EAwCM,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AAlCN;AAoCM;EACE,yBAAA;AAlCR;AAqCM;EACE,yBAAA;AAnCR;AAjBA;EA0DM,mBAAA;EACA,8BAAA;EACA,yDAAA;AAtCN;AAwCM;EACE,yDAAA;AAtCR;AAyCM;EACE,yDAAA;AAvCR;AA5BA;EAwEM,iBAAA;EACA,mBAAA;EACA,2BAAA;EACA,yDAAA;AAzCN;AA2CM;EACE,yDAAA;AAzCR;AA4CM;EACE,yDAAA;AA1CR;AA8CI;EACE,YAAA;AA5CN;AA2CI;EAGI,YAAA;AA3CR;AAwCI;EAOI,yDAAA;AA5CR;AAqCI;EAWI,yBAAA;AA7CR;AAkCI;EAeI,yDAAA;AA9CR;AA+BI;EAmBI,yDAAA;AA/CR;AAmDI;EAEI,yDAAA;AAlDR;AAgDI;EAMI,yBAAA;AAnDR;AA6CI;EAUI,yDAAA;AApDR;AA0CI;EAcI,yDAAA;AArDR;AAtEA;EAgII,eAAA;AAvDJ;AAzEA;;EAqIM,YAAA;EACA,WAAA;EACA,yBAAA;AAxDN;AA2DI;;EACE,yBAAA;AAxDN;AA2DI;;EACE,yBAAA;AAxDN;AAvFA;EAqJM,YAAA;EACA,yBAAA;AA3DN;AA8DI;EACE,yBAAA;AA5DN;AA+DI;EACE,yBAAA;AA7DN;AAjGA;EAoKI,WAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,qBAAA;EACA,kBAAA;AAhEJ;AA1GA;EA8KI,eAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AAjEJ;AAqEA;EACE;IAEI,aAAA;EApEJ;EAkEA;IAMI,iBAAA;EArEJ;AACF;AAyEA;EACE,qBAAA;EACA,gCAAA;AAvEF;AA0EA;EACE,0BAAA;AAxEF;AA2EA;EACE,WAAA;EACA,WAAA;EACA,mEAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAzEF;AAkEA;EAUI,WAAA;EACA,UAAA;EACA,mBAAA;AAzEJ;AA6DA;EAeM,WAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAzEN;AAqDA;EAuBQ,cAAA;EACA,eAAA;AAzER;AAiDA;EA4BQ,WAAA;AA1ER;AA8CA;EAgCQ,YAAA;AA3ER;AAiFA;EACE,YAAA;EACA,YAAA;AA/EF;AAkFA;EAEI,oBAAA;AAjFJ;AA+EA;EAKI,wBAAA;AAjFJ;AA4EA;EAQI,gBAAA;AAjFJ;AAyEA;EAWI,cAAA;AAjFJ;AAsEA;EAcM,cAAA;AAjFN;AAmFM;EACE,aAAA;AAjFR;AAmFM;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAjFR","sourcesContent":["@import \"pre-customizations.less\";\n@import \"../../node_modules/react-responsive-carousel/lib/styles/carousel.min.css\";\n\n@media (max-width: 768px) {\n  #propertyToSearch .table-responsive {\n    border: none;\n  }\n}\n\n#propertyToSearch table {\n  tbody {\n    cursor: pointer;\n\n    td {\n      padding: 5px 4px 5px 4px !important;\n      position: relative;\n\n      .propertyCommentBlock {\n        position: absolute;\n        width: 48em !important;\n        background: #fafafa;\n        cursor: default;\n        box-shadow: 0 1px 10px rgba(0, 0, 0, 0.6);\n        z-index: 9;\n        left: -37em;\n        top: 3.3em;\n\n        ul.infoList {\n          float: left;\n          width: 95%;\n\n          li {\n            margin: 0.5em 1em 0.5em 2em;\n          }\n\n          li:last-child {\n            margin-bottom: .5em;\n          }\n          li:first-child {\n            margin-top: .5em;\n          }\n        }\n\n      }\n    }\n\n    .btn-danger {\n      border-color: #d9534f;\n    }\n\n    .btn-danger:focus {\n      border-color: #C9302F;\n    }\n\n    .btn-danger:active {\n      border: 1px solid #c9302c;\n    }\n\n    .btn-danger:hover, .btn-danger:active:hover {\n      border-color: #c9302c;\n    }\n\n    input:focus {\n      outline: none;\n    }\n  }\n\n  .button {\n    font-style: normal;\n    padding: 2px 4px;\n    border-radius: 1px;\n    margin: 2px 2px;\n    cursor: default;\n  }\n\n}\n\n\n#propertyToSearch {\n  table {\n    tr.selected {\n      background-color: #eecd7e !important;\n      //#FFDE74 !important\n    }\n\n    th:nth-child(2) {\n      max-width: 80px;\n    }\n    th:nth-child(3) {\n      min-width: 210px;\n    }\n    th:nth-child(4) {\n      min-width: 110px;\n    }\n    th:nth-child(5) {\n      max-width: 120px;\n    }\n    th:nth-child(6) {\n      max-width: 155px;\n    }\n  }\n}\n\n#propertySearchContent {\n  overflow: hidden;\n  padding: 0 0 1em 0;\n  position: relative;\n}\n\n\n#propertySearchEditForm .wiz-wrapper-2 {\n  margin-bottom: 1em;\n}\n\n.serviceHeader {\n  display: flex;\n  flex-direction: row;\n\n  .providedBy {\n    margin-left: auto;\n    float: right;\n  }\n}\n\nul.navMenu {\n  padding: 0;\n  display: flex;\n\n  li {\n    height: 60px;\n    position: relative;\n    cursor: pointer;\n    list-style-type: none;\n    width: calc(100%  /3);\n    display: flex;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n\n    button {\n      width: 100%;\n      height: 100%;\n      padding: 0;\n      position: relative;\n      display: flex;\n      -webkit-font-smoothing: antialiased;\n      -moz-osx-font-smoothing: grayscale;\n      border: 0px;\n    }\n\n    .topTriangle {\n      border-style: solid;\n      border-width: 0 25px 30px 0;\n      border-color: transparent #d9d9d9 transparent transparent;\n\n      &.done {\n        border-color: transparent lighten(@primary, 35%) transparent transparent;\n      }\n\n      &.current {\n        border-color: transparent @primary transparent transparent;\n      }\n    }\n\n    .stepContent {\n      height: 100%;\n      width: 100%;\n      background-color: #d9d9d9;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-around;\n\n      &.done {\n        background-color: lighten(@primary, 35%);\n      }\n\n      &.current {\n        background-color: @primary;\n      }\n\n    }\n\n    .frontTriangle {\n      border-style: solid;\n      border-width: 30px 0 30px 25px;\n      border-color: transparent transparent transparent #d9d9d9;\n\n      &.done {\n        border-color: transparent transparent transparent lighten(@primary, 35%);\n      }\n\n      &.current {\n        border-color: transparent transparent transparent @primary;\n      }\n    }\n\n    .bottomTriangle {\n      justify-self: end;\n      border-style: solid;\n      border-width: 0 0 30px 25px;\n      border-color: transparent transparent #d9d9d9 transparent;\n\n      &.done {\n        border-color: transparent transparent lighten(@primary, 35%) transparent;\n      }\n\n      &.current {\n        border-color: transparent transparent @primary transparent;\n      }\n    }\n\n    &.current {\n      color: white;\n      button {\n        color: white;\n      }\n\n      .topTriangle {\n        border-color: transparent @primary transparent transparent;\n      }\n\n      .stepContent {\n        background-color: @primary;\n      }\n\n      .frontTriangle {\n        border-color: transparent transparent transparent @primary;\n      }\n\n      .bottomTriangle {\n        border-color: transparent transparent @primary transparent;\n      }\n    }\n\n    &.done {\n      .topTriangle {\n        border-color: transparent lighten(@primary, 35%) transparent transparent;\n      }\n\n      .stepContent {\n        background-color: lighten(@primary, 35%);\n      }\n\n      .frontTriangle {\n        border-color: transparent transparent transparent lighten(@primary, 35%);\n      }\n\n      .bottomTriangle {\n        border-color: transparent transparent lighten(@primary, 35%) transparent;\n      }\n    }\n  }\n  li:last-child {\n    margin-right: 0;\n  }\n\n  li:first-child {\n    .topTriangle, .bottomTriangle {\n      border: none;\n      width: 100%;\n      background-color: #d9d9d9;\n    }\n\n    &.done .topTriangle, &.done .bottomTriangle{\n      background-color: lighten(@primary, 35%);\n    }\n\n    &.current .topTriangle, &.current .bottomTriangle{\n      background-color: @primary;\n    }\n  }\n\n  li:last-child {\n    .frontTriangle {\n      border: none;\n      background-color: #d9d9d9;\n    }\n\n    &.done .frontTriangle{\n      background-color: lighten(@primary, 35%);\n    }\n\n    &.current .frontTriangle{\n      background-color: @primary;\n    }\n\n  }\n\n  .stepDesc {\n    float: left;\n    width: 100%;\n    margin: 0.25em;\n    font-size: 13px;\n    font-family: Arial, sans-serif;\n    display: inline-block;\n    text-align: center;\n  }\n\n  .stepName {\n    font-size: 17px;\n    width: 100%;\n    display: inline-block;\n    text-transform: uppercase;\n    text-align: center;\n    font-weight: bold;\n  }\n}\n\n@media (max-width: 1200px) {\n  ul.navMenu {\n    li .stepDesc {\n      display: none;\n    }\n\n    .stepName {\n      font-size: 0.94em;\n    }\n  }\n}\n\n.closePropertyCommentBlock {\n  color: red !important;\n  text-decoration: none !important;\n}\n\n.closePropertyCommentBlock:hover {\n  transform: scale(1.2, 1.2);\n}\n\n.undoContainer {\n  float: left;\n  width: 200%;\n  transition: height 600ms, left 600ms cubic-bezier(0.43, 0.01, 1, 1);\n  position: relative;\n  left: -100%;\n  overflow: hidden;\n  padding-top: 2px;\n\n  .undoBlock {\n    float: left;\n    padding: 0;\n    margin-bottom: 20px;\n\n    .undoContent {\n      float: left;\n      width: 100%;\n      background-color: #6e6e6e;\n      color: #f5f5f5;\n      padding: 0.5em 1em;\n      text-align: center;\n\n      a {\n        color: #E7B848;\n        cursor: pointer;\n      }\n\n      a.doneAction {\n        float: left;\n      }\n\n      a.undoAction {\n        float: right;\n      }\n    }\n  }\n}\n\n.docketYearPopover{\n  width:200px;\n  height:60px;\n}\n\n.carousel .slider-wrapper {\n  .formBlock {\n    margin: 3px 5px 20px;\n  }\n  .serviceBlock {\n    width: calc(100% - 10px);\n  }\n  .slide {\n    text-align: left;\n  }\n  .one-field-carousel {\n    line-height: 0;\n\n    .formBlock {\n      line-height: 1;\n\n      &:last-child {\n        display: none;\n      }\n      &.roll-in-block-small {\n        min-height: 62px;\n        display: flex;\n        align-items: center;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
